import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function isTokenValid(token: string | null): boolean {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload.exp === 'number' && payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

export default function ProtectedRoute() {
  const token = localStorage.getItem('igtoken');
  return isTokenValid(token) ? <Outlet /> : <Navigate to="/" replace />;
}
